import {
  ExtractPayload,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import {
  closeSlideOverview,
  selectSlide,
  setIsDescriptionExpanded,
  setIsNavigatorDismissed,
  setIsNodeDescriptionExpanded,
  setSlideNavigatorState,
  toggleSlideOverview,
} from './actions';
import { toggleExploreMode } from 'presentation/actions';
import { SlideNavigatorState } from './types';
import { getStoredIsNavigatorDismissed } from './navigatorPreferences';

const handleSelectSlide = (state: SlideNavigatorState, id: string | null) => ({
  ...state,
  selectedSlideId: id,
  isSlideOverviewOpen: false,
});

const handleToggleSlideOverview = (state: SlideNavigatorState) => ({
  ...state,
  isSlideOverviewOpen: !state.isSlideOverviewOpen,
});

const handleCloseSlideOverview = (state: SlideNavigatorState) => {
  if (!state.isSlideOverviewOpen) return state;
  return { ...state, isSlideOverviewOpen: false };
};

const handleToggleExploreMode = (
  state: SlideNavigatorState,
  { isExploreMode }: ExtractPayload<typeof toggleExploreMode>
) => ({
  ...state,
  isExploreMode,
});

const handleSetIsDescriptionExpanded = (
  state: SlideNavigatorState,
  isExpanded: boolean
) => ({
  ...state,
  isDescriptionExpanded: isExpanded,
});

const handleSetIsNodeDescriptionExpanded = (
  state: SlideNavigatorState,
  isExpanded: boolean
) => ({
  ...state,
  isNodeDescriptionExpanded: isExpanded,
});

const handleSetIsNavigatorDismissed = (
  state: SlideNavigatorState,
  isNavigatorDismissed: boolean
) => ({
  ...state,
  isNavigatorDismissed,
  isSlideOverviewOpen: isNavigatorDismissed ? false : state.isSlideOverviewOpen,
});

const handleSetState = (
  state: SlideNavigatorState,
  stateUpdater: Partial<SlideNavigatorState>
) => ({ ...state, ...stateUpdater });

const slideNavigator$ = persistentReducedStream(
  'slideNavigator$',
  {
    selectedSlideId: null,
    isExploreMode: false,
    slideDescription: null,
    nodeDescription: null,
    isDescriptionExpanded: true,
    isNodeDescriptionExpanded: false,
    isSlideOverviewOpen: false,
    isNavigatorDismissed: getStoredIsNavigatorDismissed(),
  },
  [
    reducer(selectSlide, handleSelectSlide),
    reducer(toggleExploreMode, handleToggleExploreMode),
    reducer(toggleSlideOverview, handleToggleSlideOverview),
    reducer(closeSlideOverview, handleCloseSlideOverview),
    reducer(setIsDescriptionExpanded, handleSetIsDescriptionExpanded),
    reducer(setIsNodeDescriptionExpanded, handleSetIsNodeDescriptionExpanded),
    reducer(setIsNavigatorDismissed, handleSetIsNavigatorDismissed),
    reducer(setSlideNavigatorState, handleSetState),
  ]
);

export { slideNavigator$ };
